const a = require("handlebars-dateformat");

export const handlebarsDateformat:any = a;
